class CrowdfundingReportStatus {
    url;
    period;
    crowdfundingPropertyId;
    constructor(data) {
        this.url = data.url;
        this.period = data.period;
        this.crowdfundingPropertyId = data.crowdfundingPropertyId;
    }
}
export default CrowdfundingReportStatus;
